import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a54eb7a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "teanback" }
const _hoisted_2 = { class: "teanback-box" }
const _hoisted_3 = { class: "teanback-title" }
const _hoisted_4 = { class: "teanback-tab" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "teanback-box" }
const _hoisted_7 = { class: "teanback-title" }
const _hoisted_8 = { class: "teanback-tab" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('play.teamUserTj') + "-" + $setup.team1), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tbname, (item, index) => {
                return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(item), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          ($setup.homePlayers)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.homePlayers, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.numbers), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.start == "0" ? _ctx.$t('match.yes') : _ctx.$t('match.nos')), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.duration), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.goal), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.backboard), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.assist), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.shot), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.threePointer), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.freeShot), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.snatch), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.frontPlate), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.backPlate), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.blockShots), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.miss), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.foul), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.jiajian), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('play.teamUserTj') + "-" + $setup.team2), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tbname, (item, index) => {
                return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(item), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          ($setup.awayPlayers)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.awayPlayers, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.numbers), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.start == "0" ? _ctx.$t('match.yes') : _ctx.$t('match.nos')), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.duration), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.goal), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.backboard), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.assist), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.shot), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.threePointer), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.freeShot), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.snatch), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.frontPlate), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.backPlate), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.blockShots), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.miss), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.foul), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(item.jiajian), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}